import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ChevronRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center bg-gray-50 overflow-hidden pt-20" data-id="element-29">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0" data-id="element-30">
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/90 to-transparent z-10" data-id="element-31" />
        {/* Placeholder for hero image - warm, family focused */}
        <div className="absolute inset-0 bg-gray-200 bg-[url('https://images.unsplash.com/photo-1599058945522-28d584b6f0ff?ixlib=rb-4.0.3&auto=format&fit=crop&w=2069&q=80')] bg-cover bg-center bg-no-repeat opacity-50" data-id="element-32" />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-33">
        <div className="max-w-2xl" data-id="element-34">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-35">
            <span className="inline-block py-1 px-3 rounded-full bg-blue-50 text-primary font-semibold text-sm mb-6 tracking-wide uppercase" data-id="element-36">
              Family-Focused Martial Arts in Brighton
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6" data-id="element-37">
              Building Confidence Through{' '}
              <span className="text-primary" data-id="element-38">Martial Arts</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-39">
              Join a community where families grow stronger together. We teach
              more than just kicks and punches—we build character, discipline,
              and self-belief in a welcoming environment.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-40">
              <Link to="/trial" data-id="element-41">
                <Button size="lg" className="w-full sm:w-auto group" data-id="element-42">
                  Start Your 4-Week Trial
                  <ChevronRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-43" />
                </Button>
              </Link>
              <Link to="/programs" data-id="element-44">
                <Button variant="outline" size="lg" className="w-full sm:w-auto" data-id="element-45">
                  View Programs
                </Button>
              </Link>
            </div>

            <div className="mt-8 flex items-center text-sm text-gray-500" data-id="element-46">
              <div className="flex -space-x-2 mr-4" data-id="element-47">
                {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full border-2 border-white bg-gray-200 overflow-hidden" data-id="element-48">
                    <img src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${i}`} alt="Student" className="w-full h-full object-cover" data-id="element-49" />
                  </div>)}
              </div>
              <p data-id="element-50">Join 200+ local families</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}